<template>
  <layout>
    <template v-slot:title>Edit Display Rule</template>
    <rule-form
      v-if="rule"
      :rule="rule"
      @save="savedOrCanceled"
      @cancel="savedOrCanceled"
    ></rule-form>
  </layout>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import RuleForm from "@/components/business-rules/RuleForm.vue";

export default {
  components: { RuleForm },
  mixins: [documentModelMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      rule: null,
    };
  },
  methods: {
    savedOrCanceled: function() {
      this.$router.push("/businessrules");
    },
  },
  mounted: function() {
    this.rule = this.documentModel.businessRules.find((r) => r.id === this.id);
  },
};
</script>
